import { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthenticationCheck";
import { GlobalStateContext } from "./GlobalStateContext";

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useContext(AuthContext);
  const { currentUser } = useContext(GlobalStateContext);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!loading) {
      setIsChecking(false);
    }
  }, [loading]);

  if (loading || isChecking) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <div>Loading user data...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has one of the required roles
  const userRole = currentUser?.type;

  const hasAccess = Array.isArray(requiredRole)
    ? requiredRole.includes(userRole)
    : userRole === requiredRole;

  if (requiredRole && !hasAccess) {
    alert('You do not have the authorization to view this page.')
    return <Navigate to="/home" replace />;
  }

  return children;
}
